<div *ngIf="!showConference">
  <po-page-default>
    <div class="row po-font-text-small po-mb-3">
      <app-step-breadcrumb [breadcrumbs]="breadcrumbs" [activeIndex]="orderCountStep"
              (breadcrumbClick)="navigateBreadcrumb($event)"></app-step-breadcrumb>
    </div>
    <app-loose-header
      (isLoading)="onLoading($event)"
      (onTerminalModalOpen)="onTerminalModalOpen()">
    </app-loose-header>
  </po-page-default>
</div>

<app-loose-conference *ngIf="showConference" [queryParamsInput]="conferenceParams"></app-loose-conference>

<po-loading-overlay
  *ngIf="loading"
  [p-screen-lock]="true"
  p-text="Carregando"
  [p-size]="'sm'">
</po-loading-overlay>

<po-modal
  #modalTerminalSelect
  p-title="Selecione o terminal"
  [p-click-out]="false"
  [p-hide-close]="true">
  <app-modal-terminal-select></app-modal-terminal-select>
</po-modal>
